import React from 'react'
import { Grid, Skeleton } from '@mui/material'

const TableSkeleton = () => {
  return (
    <Grid container direction='column' spacing={2}>
      <Grid item>
        <Skeleton
          variant='rectangular'
          height='500px'
          style={{
            borderRadius: 8
          }}
        />
      </Grid>
    </Grid>
  )
}

export default TableSkeleton
